import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { AuthProvider } from "./AuthContext";
// import { HashRouter as Router } from "react-router-dom";
import { BrowserRouter as Router } from "react-router-dom";
import "./index.css";
import { AppVersionProvider } from "./AppVersionContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <AppVersionProvider>
        <Router>
          <App />
        </Router>
      </AppVersionProvider>
    </AuthProvider>
  </React.StrictMode>,
);
